__turbopack_context__.v({
  "BackToTop": "BackToTop-module__VQI20W__BackToTop",
  "icon": "BackToTop-module__VQI20W__icon",
  "show": "BackToTop-module__VQI20W__show",
});
